import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./DescriptionParametersSection.module.scss";

export default function DescriptionParametersConfirmDialog({
  open,
  title,
  body,
  closeLabel,
  discardLabel,
  keepLabel,
  onDiscard,
  onKeep
}) {
  return (
    <Dialog
      open={open}
      onClose={onKeep}
      fullWidth
      maxWidth="xs"
      transitionDuration={{ enter: 160, exit: 40 }}
      PaperProps={{ className: styles.confirmPaper }}
      aria-labelledby="description-confirm-title"
    >
      <div className={styles.confirmTitle}>
        <h2 id="description-confirm-title">{title}</h2>
        <IconButton aria-label={closeLabel} onClick={onKeep}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={styles.confirmContent}>
        <p>{body}</p>
      </DialogContent>
      <DialogActions className={styles.confirmActions}>
        <Button variant="outlined" onClick={onDiscard}>
          {discardLabel}
        </Button>
        <Button autoFocus variant="contained" color="primary" onClick={onKeep}>
          {keepLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DescriptionParametersConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  closeLabel: PropTypes.string.isRequired,
  discardLabel: PropTypes.string.isRequired,
  keepLabel: PropTypes.string.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};
